export const simpleQuizz = {
  id: "simpleQuizz",
  title: "À vous de Jouer !",
  details: null,
};

// Vous pouvez ajouter d'autre questionnaire sous le même format.
export const detailedQuizz = {
  id: "detailedQuizz",
  title: "Version détaillée",
  details: "Accès à plus d'options",
};

// Il faudra ajouter le nouveau questionnaire dans quizzVersions, puis aller dans ./Application/QuizzChoice et désindenter ce qu'il faut !.
export const quizzVersions = [simpleQuizz, detailedQuizz];
